<template>
  <div class="relative">
    <!-- Bundle Sidebar -->
    <div class="mb-4 border border-gray-500">
      <h4 class="bundle-title">{{ strings.title }}</h4>

      <div v-if="bundle.length > 0">
        <div
          v-for="(item, index) in bundle"
          :key="index"
          class="bundle-item-wrapper"
        >
          <span class="item-name">{{ item.name }}</span>
          <span class="item-variation">{{ item.variation }}</span>

          <div class="flex justify-between mx-3">
            <span v-if="item.variation_price" class="item-variation-price">
              ${{
                item.variation_price.toLocaleString('en-US', {
                  minimumFractionDigits: 2
                })
              }}
            </span>

            <div
              v-if="item.productId !== insulatedContainerProductId"
              class="item-quantity"
            >
              <input
                @change="onQuantity($event, item.id)"
                type="number"
                step="1"
                min="1"
                :name="'item_' + item.id"
                :value="item.quantity"
                size="2"
              />
            </div>
          </div>

          <span
            v-if="item.isTempSensitive"
            class="block absolute bottom-2 left-3 mt-1 font-bold uppercase text-purple-500 text-xs"
          >
            {{ strings.tempsensitive_title }}
          </span>

          <div
            v-if="item.productId !== insulatedContainerProductId"
            class="item-remove"
          >
            <span @click="remove(item.checkboxName)">
              <svg viewBox="12.1 9.11 30 28.7" class="w-3 h-3 fill-current">
                <path
                  d="M30.25 23.78l11.55 11c.2.19.3.4.3.65s-.1.47-.3.66l-1.5 1.43a.99.99 0 01-1.38 0L27.29 26.46l-.14.02c-.07 0-.14-.02-.21-.04L15.29 37.52a.99.99 0 01-1.38 0l-1.5-1.43c-.2-.19-.3-.41-.3-.66s.1-.46.3-.65L24 23.73 12.56 12.27a.94.94 0 010-1.37l1.49-1.5a.94.94 0 011.37 0l11.73 11.74L38.88 9.41a.94.94 0 011.37 0l1.5 1.5c.2.2.3.42.3.68 0 .26-.1.49-.3.69l-11.5 11.5z"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div
        class="p-4 bg-gray-200 text-center font-bold text-sm uppercase"
        v-else
      >
        <p>{{ strings.empty }}</p>
      </div>
    </div>

    <div
      class="bg-purple-100 border-purple-500 border mb-4 py-4 px-4 text-gray-650 text-xs"
      v-if="showTempSensitiveNotice"
    >
      <strong
        class="block text-base text-center text-purple-500 uppercase mb-2"
        >{{ strings.tempsensitive_title }}</strong
      >
      <p>
        {{ strings.tempsensitive_text }}
      </p>
    </div>

    <box :strings="strings"></box>

    <div class="bundle-price-wrapper">
      <div class="hidden md:flex select-none">
        <label class="checkbox" for="multipleBoxes">
          <input
            v-model="multipleBoxes"
            type="checkbox"
            class="!w-5 !h-5"
            id="multipleBoxes"
            name="multiple_boxes"
          />

          <span
            class="uppercase ml-1 inline-flex mt-1 mb-2 leading-none text-gray-600 text-sm"
            >{{ strings.multiple_boxes }}</span
          >
        </label>
      </div>

      <span
        v-if="multipleBoxes"
        :class="{ 'pt-1': multipleBoxes }"
        class="bundle-price-per-box"
      >
        <strong>{{ strings.priceperbox }}:</strong> ${{ pricePerBox }}
      </span>

      <span :class="{ 'py-1': !multipleBoxes }" class="bundle-subtotal">
        <strong>{{ strings.subtotal }}:</strong> ${{ totalPrice }}
      </span>
    </div>
  </div>
</template>

<script>
import Box from './Box';

export default {
  data () {
    return {
      bundle: [],
      price: 0,
      quantity: 1,
      showTempSensitiveNotice: false,
      multipleBoxes: false,
      insulatedContainerProductId: null
    };
  },
  props: {
    strings: {
      type: Object,
      default: null
    }
  },
  components: {
    Box
  },
  computed: {
    pricePerBox () {
      return this.price.toLocaleString('en-US', { minimumFractionDigits: 2 });
    },
    totalPrice () {
      let price = parseFloat(this.price * this.quantity);

      return price.toLocaleString('en-US', { minimumFractionDigits: 2 });
    }
  },
  watch: {
    // whenever checkbox changes, this function will run
    multipleBoxes (newValue) {
      const elm = document.querySelector('.bundle_button .quantity');

      const inputMessageElm = document.querySelector(
        '.bundle_form .cart.bundle_data .input-label'
      );

      if (newValue) {
        // Show the quanity input
        elm.style = 'display: block;';
        inputMessageElm.classList.remove('!hidden');
      } else {
        elm.style = 'display: none;';
        inputMessageElm.classList.add('!hidden');

        document.getElementsByName('quantity')[0].value = 1;
        this.quantity = 1;
      }
    },
    bundle: {
      handler: function (newValue) {
        this.showTempSensitiveNotice = newValue.some(function (value) {
          if (value.isTempSensitive) {
            return true;
          }
        });

        this.bundle = newValue;

        // Make sure we add the insulated container.
        const insulatedContainer = document.querySelector(
          '[data-product_id="' + this.insulatedContainerProductId + '"]'
        );

        const bundledItemId = insulatedContainer.dataset.bundled_item_id;

        const bundledItemSelector =
          '[name=bundle_selected_optional_' + bundledItemId + ']';

        if (this.showTempSensitiveNotice) {
          document.querySelector(bundledItemSelector).checked = true;

          $(bundledItemSelector).trigger('change');
        } else {
          document.querySelector(bundledItemSelector).checked = false;

          $(bundledItemSelector).trigger('change');
        }

        this.buttonState();
      }
    }
  },
  methods: {
    buttonState () {
      const addToCartBtn = document.querySelector('.bundle_add_to_cart_button');

      if (this.bundle.length > 0) {
        addToCartBtn.disabled = false;
      } else {
        addToCartBtn.setAttribute('disabled', 'disabled');
      }
    },
    updateQuantity (event) {
      this.quantity = event.target.valueAsNumber;

      if (this.quantity > 1) {
        this.multipleBoxes = true;
      }
    },
    onBundle (event) {
      this.bundle = event.detail.data;
      this.price = event.detail.price;
    },
    onQuantity (event, id) {
      // Update the input value.
      document.getElementById(id).value = event.target.value;

      // Trigger the jQuery event (Eeeek).
      $('#' + id).trigger('change');
    },
    remove (checkboxName) {
      // Update the DOM.
      document.querySelector('[name=' + checkboxName + ']').checked = false;

      // Trigger the jQuery event (Eeeek).
      $('[name=' + checkboxName + ']').trigger('change');
    }
  },
  mounted () {
    document
      .querySelector('.bundle_form .cart.bundle_data')
      .addEventListener('bundled-products', this.onBundle);

    document
      .getElementsByName('quantity')[0]
      .addEventListener('input', this.updateQuantity);

    this.quantity = parseInt(document.getElementsByName('quantity')[0].value);

    if (this.quantity > 1) {
      this.multipleBoxes = true;
    }

    this.buttonState();

    this.insulatedContainerProductId = parseInt(
      window.thefinercookieJS.insulated_container_product_id
    );
  }
};
</script>
